import { render } from "./ver-gastos.vue?vue&type=template&id=22efc238&scoped=true"
import script from "./ver-gastos.vue?vue&type=script&lang=js"
export * from "./ver-gastos.vue?vue&type=script&lang=js"

import "./ver-gastos.vue?vue&type=style&index=0&id=22efc238&scoped=true&lang=css"
import "./ver-gastos.vue?vue&type=style&index=1&id=22efc238&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22efc238"]])

export default __exports__